export default "__VITE_ASSET__BlE6_eUU__"